export default {
  getPois(state) {
    return state.pois;
  },
  getPoi: (state) => (poiType) => {
    return state.pois[poiType];
  },
};
